import { useLoaderData, useNavigate, Outlet } from 'react-router-dom'
import Stack from '@mui/material/Stack'

import { LoaderData } from '../../types'
import { EventsList } from './components/EventsList'
import { abstractReviewListEventsLoader } from './Abstracts.loader'

export default function AbstractsEvaluationListLayout() {
  const navigate = useNavigate()
  const events = useLoaderData() as LoaderData<ReturnType<typeof abstractReviewListEventsLoader>>

  return (
    <Stack
      flex="1 0"
      direction={{ sm: 'column', md: 'row' }}
      width="100%"
      height="inherit"
      sx={theme => ({
        background: theme.colors.whiteBackground,
      })}
    >
      <EventsList
        events={events ?? []}
        onClick={id => {
          navigate(`/abstracts/evaluation/${id}`)
        }}
      />

      <Outlet />
    </Stack>
  )
}
